import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';

import type { JiraContextData } from './jira-draft-data-command';

export interface JiraDraftDataForCreateAllCommandProperties extends CommandProperties {}

/**
 * Result type for the Jira context command.
 */
export type JiraDraftDataForCreateAllCommandResult = {
	success: boolean;
	context: JiraContextData;
	error?: string;
};

/**
 * A command sent by a bridge API client to retrieve Jira-specific context
 * information when operating in a Jira staging area environment.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to provide current Jira context information.
 */
export const JiraDraftDataForCreateAllCommand = createCommand<
	JiraDraftDataForCreateAllCommandProperties,
	JiraDraftDataForCreateAllCommandResult
>('jira-context-for-create-all-command');
